import { Typography } from '@mui/material';
import { dialogOverlay, StyledDialogContent } from '../styles';
import { GenericModal } from '../../../shared/GenericModal';
import { BlinkingAbyssLoader } from '@/components/shared/BlinkingAbyssLoader';

type Props = { open: boolean };

export const ValidateFileModal = ({ open }: Props) => {
  return (
    <>
      <GenericModal
        open={open}
        handleClose={() => {}}
        crossIconStyle={{ display: 'none' }}
        headerStyleProp={{ display: 'none' }}
        sx={{ ...dialogOverlay, left: '27% !important', width: 1027, height: 478 }}
      >
        <StyledDialogContent>
          <BlinkingAbyssLoader />
          <Typography color="initial" mt={3} fontSize="1.3rem">
            Validating the file. This may take a few seconds.
          </Typography>
        </StyledDialogContent>
      </GenericModal>
    </>
  );
};
